import { StatusUpdateScope } from "tekkr-common/dist/model/project/chat";
import { DateTime } from "luxon";

export function getScopeLabel(scope: StatusUpdateScope): string {
    switch (scope.type) {
        case "days":
            return `Last ${scope.days} days`;
        case "since_last_update":
            return "Since last update";
        case "since_project_start":
            return "Since project start";
        case "custom":
            return `${DateTime.fromISO(scope.startDate).toLocaleString({
                month: "short",
                day: "numeric",
            })} - ${DateTime.fromISO(scope.endDate).toLocaleString({
                month: "short",
                day: "numeric",
            })}`;
        default:
            return "Custom range";
    }
}
